<ion-app [class.ios]="isIosPlatform | async">
    @if (isEmptyConnection$ | async) {
        <div class="network-message">
            <ion-icon name="cloud-offline-outline"></ion-icon>
            {{ 'errors.empty-connection' | translate }}
        </div>
    }
    <div class="app-container" cdkScrollable>
        <ncodp-accessibility-panel></ncodp-accessibility-panel>
        <ncodp-header></ncodp-header>
        <ion-router-outlet #routerOutlet class="sub-routes"></ion-router-outlet>
        <ncodp-footer></ncodp-footer>

        <ion-fab [class.visible]="showGlobalScrollTop()" horizontal="end" slot="fixed" vertical="bottom">
            <ion-fab-button (click)="scrollToTop()" size="small">
                <ion-icon color="light" name="chevron-up-outline"></ion-icon>
            </ion-fab-button>
        </ion-fab>
    </div>
</ion-app>

@if (isLoadingDrug()) {
    <div class="table-loader">
        <ion-spinner name="dots"></ion-spinner>
    </div>
}
